import React from 'react';
import { Col, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useSiteState } from '../../state/state';
import ReactMarkdown from 'react-markdown';
import { Controller, useFormContext } from 'react-hook-form';
import { CheckinForm } from '../../service/checkin-flow';

type HealthDeclarationProps = {
    onSelectionMade: () => void,
}

export const HealthDeclaration = ({ onSelectionMade }: HealthDeclarationProps) => {
    const { declaration, settings } = useSiteState();
    const { control } = useFormContext<CheckinForm>();

    const getClassNameForConfirm = (value: string, declarationLogicSwitched: boolean | undefined): string =>
    {
        if (declarationLogicSwitched) {
            return `${value === 'yes' ? 'action-button-selected' : ''} action-button mr-3 rounded`;
        } else {
            return `${value === 'yes' ? 'action-button-selected action-error' : ''} action-button mr-3 rounded`;
        }
    }

    const getClassNameForDeny = (value: string, declarationLogicSwitched: boolean | undefined): string =>
    {
        if (declarationLogicSwitched) {
            return `${value === 'no' ? 'action-button-selected action-error' : ''} action-button mr-3 rounded`;
        } else {
            return `${value === 'no' ? 'action-button-selected' : ''} action-button mr-3 rounded`;
        }
    }

    return (
        <div className="summary-block">
            <Row className='mt-2'>
                <Col className='med-heading'>
                    {settings?.declarationLabel ? settings?.declarationLabel : 'Health Declaration'}
                </Col>
            </Row>
            <Row className='my-2 body-text'>
                <Col className='larger declaration'>
                    {declaration && <ReactMarkdown linkTarget='_blank' source={declaration} />}
                </Col>
            </Row>
            {!!settings?.declarationAnswer ? (
                <Row>
                    <Col className='text-center'>
                        <Controller name='declaration' control={control}
                                    defaultValue=''
                                    render={({onChange, onBlur, value }) => (
                                        <ToggleButtonGroup name='declaration'
                                                           className='w-100'
                                                           type='radio'
                                                           value={value}
                                                           onChange={v => {
                                                               onChange(v);
                                                               onSelectionMade();
                                                           }}
                                                           onBlur={onBlur}>
                                            <ToggleButton
                                                className={getClassNameForConfirm(value, settings?.declarationLogicSwitched)}
                                                variant='light'
                                                value='yes'>YES</ToggleButton>
                                            <ToggleButton
                                                className={getClassNameForDeny(value, settings?.declarationLogicSwitched)}
                                                variant='light'
                                                value='no'>NO</ToggleButton>
                                        </ToggleButtonGroup>
                                    )} />
                    </Col>
                </Row>
            ) : null}
        </div>
    );
}
